import React, { useState, useEffect } from "react";
import {
  Alert,
  Table,
  Card,
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  CardTitle,
  CardBody,
  Col,
  Row
} from "reactstrap";
import axios from "axios";
import { Link, useCurrentRoute } from "react-navi";
import Container from "./components/Container";
import machineService from "../services/api/machineService";

export function Home(props) {
  const [deleteSuccessful, setDeleteSuccessful] = useState(false);
  const [uploadSuccessful, setUploadSuccessful] = useState(false);
  const [machines, setMachines] = useState(null);

  const route = useCurrentRoute();

  async function handleDelete(event) {
    const machineId = event.target.value;
    const confirm = window.confirm(
      "Are you sure you want to delete this machine?"
    );
    if (!confirm) return;

    const newMachines = machines.filter(
      machine => machine.machineId !== machineId
    );

    setMachines(newMachines);

    machineService.deleteMachine(machineId);
  }

  useEffect(() => {
    setMachines(route.data.machines);
  }, [route.data.machines]);

  const machineCards = machines
    ? machines.map((item, index) => {
        return (
          <Card
            color={
              machines.length === index + 1 &&
              route.data &&
              route.data.uploadSuccessful
                ? "danger"
                : ""
            }
            outline
            key={item.machineId}
            className="m-3 card-black"
          >
            <CardBody>
              <CardTitle>
                <b>Machine {index + 1}</b>
              </CardTitle>
              <div className="table table-responsive">
                <Table>
                  <tbody>
                    <tr>
                      <th>Machine ID</th>
                      <td>{item.machineId}</td>
                    </tr>
                    <tr>
                      <th>Machine name</th>
                      <td>{item.machineName}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>

              <Row className="d-flex justify-content-center">
                <Link
                  href={`machines/${item.machineId}/configs`}
                  className="btn btn-black btn-outline-dark m-2"
                >
                  Configs
                </Link>
                <UncontrolledButtonDropdown className="">
                  <DropdownToggle
                    outline
                    className="btn btn-black btn-outline-dark m-2"
                    caret
                  >
                    Actions
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      tag={Link}
                      href={`machines/${item.machineId}`}
                    >
                      Edit
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      value={item.machineId}
                      onClick={handleDelete}
                      className="text-danger"
                    >
                      Delete
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </Row>
            </CardBody>
          </Card>
        );
      })
    : null;

  // this array will be filled with  rows of machine cards
  const rows = [];
  if (machines) {
    for (let i = 0; i < machineCards.length; i += 2) {
      rows[i] =
        i < machineCards.length - 1 ? ( // two machines per row
          <Row key={i} className=" d-flex justify-content-center">
            <Col>{machineCards[i]}</Col>
            <Col>{machineCards[i + 1]}</Col>
          </Row>
        ) : (
          // last machine needs to be in a single column so it's nicely centered
          <Row key={i} className=" d-flex justify-content-center">
            <Col className=" col-xs-12 col-sm-12 col-lg-6 col-xl-6 col-md-6">
              {machineCards[i]}
            </Col>
          </Row>
        );
    }
  }

  return (
    <Container title="Available machines">
      <Link
        href="/machines/create"
        className="btn btn-black btn-block btn-outline-dark"
      >
        Create machine
      </Link>
      <hr className="hr-black" />
      {rows}
    </Container>
  );
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/home.jsx